import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PurchaseService, DownloadInfo } from '../services/purchase.service';
import {environment} from '../../environments/environment';

// Landing on this page does NOT use up the link (so email scanners that open
// links don't burn it). Only the button below, which hits /file, does.
@Component({
  selector: 'app-download',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './purchase-download.component.html',
  styleUrl: './purchase-download.component.css'
})
export class DownloadComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private purchases = inject(PurchaseService);

  info?: DownloadInfo;
  fileUrl = '';

  ngOnInit() {
    const token = this.route.snapshot.paramMap.get('token') ?? '';
    this.fileUrl = environment.apiBaseCommerceUrl + `/api/downloads/${encodeURIComponent(token)}/file`;
    this.purchases.download(token).subscribe({
      next: (info) => (this.info = info),
      error: () => (this.info = { status: 'NOT_FOUND' }),
    });
  }
}
